import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Element from "element-ui";
import axios from "axios";
import echarts from "echarts";
import formcrate, { maker } from "@form-create/element-ui";
import Chat from "jwchat";

// 富文本编辑器
// import'../static/Ueditor/ueditor.config.js'
// import'../static/Ueditor/ueditor.all.min.js'
// import'../static/Ueditor/lang/zh-cn/zh-cn.js'
// import'../static/Ueditor/ueditor.parse.min.js'

import "element-ui/lib/theme-chalk/index.css";

// // 点击图片放大
// // import Vue from 'vue';
// import Viewer from 'v-viewer';
// import 'viewerjs/dist/viewer.css';
// Vue.use(Viewer)
// Viewer.setDefaults({
//   Options: {
//     'inline': true,
//     'button': true,
//     'navbar': true,
//     'title': true,
//     'toolbar': true,
//     'tooltip': true,
//     'movable': true,
//     'zoomable': true,
//     'rotatable': true,
//     'scalable': true,
//     'transition': true,
//     'fullscreen': true,
//     'keyboard': true,
//     'url': 'data-source'
//   }
// })

// import "element-ui/lib/theme-chalk/index.css";

Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;

Vue.use(Element);
Vue.use(formcrate);
Vue.use(Chat);

var currentDomain = process.env.VUE_APP_BASE_URL;
// console.log(process.env.VUE_APP_BASE_URL, "currentDomain");
// var loginUrl = "http://pw.ruizhiqi.cn/SSOLogin/Index?url=" + currentDomain;
// axios.defaults.baseURL = "http://pw.ruizhiqi.cn/";
var loginUrl = "http://pw.ruizhiqi.cn/SSOLogin/Index?url=" + currentDomain;
axios.defaults.baseURL = "http://pw.ruizhiqi.cn";

Vue.prototype.$http = axios;
window.axios = axios;
Vue.prototype.$loginUrl = loginUrl;
Vue.prototype.$currentDomain = currentDomain; //配置请求的根路径

//FastClick.attach(document.body);
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
